<template lang="pug">
#Usuarios
    el-card.mb-4.box-card(shadow='never', :body-style='{ padding: "10px" }')
        el-collapse(v-model='currentCollapseItem')
            el-collapse-item(name='filtros')
                template(slot='title')
                    .titulo-collapse
                        i.mdi.mdi-filter-variant.mr-2(style='font-size: 20px')
                        | {{ $t('mensagens.usuarios.admin.label') }}

                el-form.row.m-0.px-2(label-position='top', size='mini')
                    el-form-item.col-12.p-0
                        label.mb-0 {{ $t('mensagens.usuarios.empresa') }}
                        el-select(
                            v-model='filtros.empresas',
                            style='width: 100%',
                            :placeholder="$t('mensagens.usuarios.modalUsuario.selecionar')",
                            multiple,
                            value-key='id'
                        )
                            el-option.titulo-empresas(
                                v-for='empresa in empresas',
                                :key='empresa.id',
                                :label='empresa.name',
                                :value='empresa.id'
                            )

                    el-form-item.col-10.p-0
                        label.mb-0 {{ $t('mensagens.usuarios.admin.dataCadastro') }}
                        .d-flex
                            el-date-picker(
                                v-model='filtros.dataCadastroInicio',
                                placement='bottom-start',
                                type='date',
                                :placeholder="$t('mensagens.usuarios.modalUsuario.selecionar')",
                                format='dd/MM/yyyy'
                            )
                            span.mx-3 à
                            el-date-picker(
                                v-model='filtros.dataCadastroFim',
                                placement='bottom-start',
                                type='date',
                                :placeholder="$t('mensagens.usuarios.modalUsuario.selecionar')",
                                format='dd/MM/yyyy'
                            )

                    el-form-item.col-2.p-0.align-items-end.d-flex.justify-content-end
                        BaseButton(icon='el-icon-delete', @click='limparFiltro') {{ $t('mensagens.usuarios.admin.limpar') }}
                        BaseButton(
                            type='primary',
                            icon='el-icon-receiving',
                            @click='buscarUsuarios(true)',
                            :disabled='!hasEmpresaSelecionada'
                        ) {{ $t('mensagens.usuarios.admin.filtrar') }}

    el-card.mb-4.box-card(
        v-if='possuiUsuarios && possuiDadosGrafico',
        shadow='never',
        :body-style='{ padding: "10px" }'
    )
        ChartLine(
            chartId='lineId',
            :chartData='chartData',
            :chart-options='chartOptions'
        )

    el-card.box-card(
        v-if='possuiUsuarios',
        shadow='never',
        :body-style='{ padding: "10px" }'
    )
        el-table.px-2(:data='usuarios.data', size='mini', height='350')
            el-table-column(:label="$t('mensagens.usuarios.admin.nomeUsuario')", prop='nome', sortable)
            el-table-column(:label="$t('mensagens.usuarios.empresa')", prop='empresa', sortable)
            el-table-column(
                :label="$t('mensagens.usuarios.admin.dataCadastro')",
                prop='dataCadastro',
                align='center'
            )
            el-table-column(
                :label="$t('mensagens.usuarios.admin.dataUltimoAcesso')",
                prop='dataUltimoLogin',
                align='center'
            )
            el-table-column(
                :label="$t('mensagens.usuarios.admin.totalAcessos')",
                prop='totalAcessos',
                align='center',
                sortable
            )

        .mt-4.px-2.justify-content-between.d-flex.align-items-center
            BaseButton(
                type='primary',
                icon='el-icon-document',
                @click='exportarDados()',
                size='mini'
            ) {{ $t('mensagens.usuarios.admin.exportarDados') }}
            el-pagination(
                small,
                background,
                layout='prev, pager, next',
                :page-size='usuarios.pageable.pageSize',
                :current-page.sync='usuarios.pageable.currentPage + 1',
                :page-count='usuarios.pageable.pages',
                :total='usuarios.pageable.total',
                @current-change='irParaPagina'
            )
            label.label-soma {{ `Σ ${$t('mensagens.usuarios.admin.totalRegistros')}: ${usuarios.pageable.total}` }}
</template>

<script>
import ChartLine from '@/components/charts/GraficoLine';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'Usuarios',
    components: {
        ChartLine,
        BaseButton
    },

    emits: [
        'buscarEmpresas',
        'buscarUsuarios',
        'exportarDados',
        'limparFiltros'
    ],

    props: {
        empresas: {
            type: Array,
            required: true,
            default: () => []
        },
        labelsGrafico: {
            type: Array,
            required: true,
            default: () => []
        },
        dadosGrafico: {
            type: Object,
            required: true,
            default: () => {}
        },
        usuarios: {
            type: Array,
            required: true,
            default: () => []
        }
    },

    computed: {
        hasEmpresaSelecionada() {
            return this.filtros.empresas.length > 0;
        },

        possuiUsuarios() {
            return this.usuarios.length > 0;
        },

        possuiDadosGrafico() {
            return (
                Object.keys(this.dadosGrafico).length > 0 &&
                this.labelsGrafico.length > 0
            );
        }
    },

    data() {
        return {
            chartData: {
                labels: [],
                datasets: []
            },
            chartOptions: {
                plugins: {
                    legend: {
                        position: 'bottom'
                    },
                    title: {
                        display: true,
                        text: 'Evolução de usuários'
                    }
                },
                parsing: {
                    xAxisKey: 'data',
                    yAxisKey: 'usuarios'
                },
                responsive: true,
                maintainAspectRatio: false
            },
            currentCollapseItem: ['filtros'],
            filtros: {
                empresas: [],
                dataCadastroInicio: null,
                dataCadastroFim: null,
                page: 0
            }
        };
    },

    watch: {
        labelsGrafico: function (currValue) {
            this.chartData.labels = [];
            this.chartData.labels = currValue;
        },
        dadosGrafico: function () {
            this.chartData.datasets = [];

            Object.keys(this.dadosGrafico).forEach(empresa => {
                const corEmpresa =
                    '#' + Math.floor(Math.random() * 16777215).toString(16);
                this.chartData.datasets.push({
                    label: this.captalize(empresa),
                    backgroundColor: corEmpresa,
                    borderColor: corEmpresa,
                    data: this.dadosGrafico[empresa]
                });
            });
        },
        usuarios: function (currValue, oldValue) {
            if (oldValue.length === 0 && currValue.length > 0) {
                this.currentCollapseItem = [];
            }
        }
    },

    mounted() {
        this.buscarEmpresas();
    },

    methods: {
        buscarEmpresas() {
            this.$emit('buscarEmpresas');
        },

        buscarUsuarios(reiniciarPaginas) {
            if (reiniciarPaginas) this.filtros.page = 0;
            this.$emit('buscarUsuarios', this.filtros);
        },

        captalize(empresa) {
            const nomeEmpresa = empresa.toLowerCase().replaceAll('_', ' ');
            return nomeEmpresa.replace(/(?:^|\s)\S/g, a => a.toUpperCase());
        },

        exportarDados() {
            this.$emit('exportarDados', this.filtros);
        },

        limparFiltro() {
            this.filtros = {
                empresas: [],
                dataCriacaoInicio: null,
                dataCriacaoFim: null,
                page: 0
            };
            this.$emit('limparFiltros');
        },

        irParaPagina(pagina) {
            this.filtros.page = pagina - 1;
            this.buscarUsuarios(false);
        }
    }
};
</script>

<style lang="scss">
#Usuarios {
    .el-collapse-item__content {
        padding: 0;
    }

    .el-collapse-item__wrap {
        border-bottom: 0;
    }

    .titulo-empresas {
        text-transform: capitalize;
    }

    .titulo-collapse {
        display: flex;
        align-items: center;
        font-size: 14px;
        font-weight: bold;
    }

    .label-soma {
        color: #19194b;
        font-size: 12px;
    }
}
</style>
